<template>
  <div class="booking-table">
    <table class="table-fixed w-full">
      <thead class="bg-gray-500 text-white text-left">
        <th
          class="w-3/20 pr-12 py-3 font-semibold text-xs rounded-l-md text-right"
        >
          Quantity
        </th>
        <th class="w-3/20 px-8  py-3 font-semibold text-xs">Package type</th>
        <th class="w-4/20 px-8  py-3 font-semibold text-xs">Type of goods</th>
        <th class="w-4/20 pl-8  py-3 font-semibold text-xs">Description</th>
        <th class="w-3/20 px-8  py-3 font-semibold text-xs text-right">
          Weight (Kg)
        </th>
        <th
          class="w-3/20 pr-12  py-3 font-semibold text-xs rounded-r-md text-right"
        >
          Volume (m<sup>3</sup>)
        </th>
      </thead>

      <tbody>
        <tr v-for="data in tableData" class="text-xs text-gray-700">
          <td class="py-3 pr-12 text-right">{{ data.quantity }}</td>
          <td class="py-3 px-8 text-left">{{ data.packageType }}</td>
          <td class="py-3 px-8 text-left">{{ data.typeOfGoods }}</td>
          <td class="py-3 pl-8 text-left">{{ data.description }}</td>
          <td class="py-3 px-8 text-right">{{ Math.trunc(data.weight) }}</td>
          <td class="py-3 pr-12 px-8 text-right">{{ data.volume }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import expandDgLines from "./ExpandDgLines";

export default {
  name: "GuestFreightLines",
  components: { expandDgLines },
  props: ["tableData", "hasDgs"],

  computed: {
    typeOfGoodsWidth: function() {
      return this.hasDgs ? 230 : 260;
    },
  },
};
</script>

<style>
tr:nth-child(even) {
  background-color: #f7fafc;
}
</style>
